import { useNavigate } from "react-router-dom";

export const useNavigateToModule = (slug: string) => {
  const navigate = useNavigate();

  const navigateToModule = () => {
    navigate(`/LearningHub/Modules/${slug}`);
  }

  return navigateToModule;
}
